import axios from '../../../../utills/axiosConfig';

export const fetchCollections = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/collections', { params });
  return res.data;
};

export const addCollection = async (collection) => {
  try {
    const res = await axios.post('/collections', collection);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateCollection = async (id, collection) => {
  const res = await axios.put(`/collections/${id}`, collection);
  return res.data;
};

export const deleteCollection = async (id) => {
  const res = await axios.delete(`/collections/${id}`);
  return res.data;
};

export const importCollectionCSV = async (formData) => {
  const { data } = await axios.post('/collections/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 